<div class="tabs-header__container">
  <ion-list-header class="tabs-header">
    <ion-label class="tabs-header__title">{{paymentStore.customer?.givenName}}'s tab</ion-label>
    <ion-button (click)="close()" class="cart-header__close-btn" fill="clear" color="dark">
      <svg
        slot="icon-only"
        class="tabs-header__close-btn-icon"
        aria-label="Cart image"
      >
        <use xlink:href="./assets/images/icons-sprite.svg#icon-close"></use>
      </svg>
    </ion-button>
  </ion-list-header>
  <div class="divider"></div>
</div>
<ion-content class="container">
  <main>
    <div class="container__content">
      <div class="order-tab__container">
        <app-tab-order-status *ngFor="let orderStatus of tabOrdersStatus;  let first = first;" [tabOrdersStatus]="orderStatus" [first]="first ? true : false"></app-tab-order-status>
      </div>
    </div>
  </main>
  <ion-button (click)="goToCloseTabPage()" class="container__button" expand="block" color="brand" [disabled]="cartStore.updateCartInProgress">
    <div class="container__button-text">Close tab</div>
  </ion-button>
</ion-content>
